export default {
    title: 'Timetable Setting',
    searchText: 'Search by Bureau',
    search: 'Search',

    bureau: 'Bureau',
    acronym: 'Acronym',
    workDay: 'Work day',
    totalEmployee: 'Total Employee',
    updatedDate: 'Recent Update',
    createdDate: 'Date Created',
    action: ''
}
